// TaskCount.jsx
import { Card, Button, Badge } from 'antd';
import { BsClipboardCheck } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react'
import useWBSRepo from "../../services/repo/useWBSRepo";

export default function TaskCount() {
    const navigate = useNavigate();
    const [taskCount, setTaskCount] = useState(0);
    const WBSRepo = useWBSRepo();

    useEffect(() => {
        WBSRepo.getWBSTotalList()
            .then((res) => {
                if (res?.status === 200) {
                    setTaskCount(res.data);
                }
            })
            .catch((err) => {
                console.error("Failed to fetch task count", err);
            });
    }, []);

    return (
       <Button
        type="text"
        onClick={() => navigate('/app/task/list')}
        style={{
          height: 32,
          lineHeight: '32px',
          borderRadius: 16,
          background: '#E6FFFB',
          padding: '0 10px',
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }}
      >
        <BsClipboardCheck size={16} style={{ color: '#08979C' }} />
        <Badge
          count={taskCount}
          overflowCount={999}
          size="small"
          style={{ backgroundColor: '#08979C' }}
        />
        <span style={{ color: '#595959', fontSize: 12 }}>Task List</span>
      </Button>
    );
}
